module.exports = __webpack_public_path__ + "static/media/bg-appselector.1e599581.jpg";